module.exports = __webpack_public_path__ + "img/right.20678310.svg";